import useScrollProgress from "../../hooks/useScrollProgress";

const ScrollProgressBar = () => {
  const { progress } = useScrollProgress();

  return (
    <div className="scroll-progress" aria-hidden="true">
      <span className="scroll-progress__fill" style={{ width: `${progress * 100}%` }} />
    </div>
  );
};

export default ScrollProgressBar;
